document.addEventListener("DOMContentLoaded", function () {
    const paymentContainer = document.querySelector(".product-form__payment-container");

    if (!paymentContainer || window.innerWidth > 768) return;

    const isFloatingBtn = paymentContainer.getAttribute("data-floating-btn") === "true";
    if (!isFloatingBtn) return;

    let isFloating = false;

    // Dynamically create a small invisible sentinel just above the paymentContainer
    const sentinel = document.createElement('div');
    sentinel.style.height = '1px';
   sentinel.setAttribute("style", "display: block !important;");
    sentinel.classList.add('floating-sentinel');
    sentinel.style.marginBottom = '5px';

    paymentContainer.parentNode.insertBefore(sentinel, paymentContainer);

    // Set up the intersection observer on the new sentinel
    const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting && !isFloating) {
            isFloating = true;
            paymentContainer.classList.add("visible");
        } else if (entry.isIntersecting && isFloating) {
            isFloating = false;
            paymentContainer.classList.remove("visible");
        }
    }, {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px',
    });

    observer.observe(sentinel);
});




document.addEventListener("click", function (event) {
    if (event.target.classList.contains("picky-cart-item__remove-button")) {
        event.preventDefault();
        console.log("Remove button clicked", event.target);
        
    }
});

